<template>
  <div class="page-container">
    <div id="print-template" class="print-card">
      <div class="section">
        <span class="prefix">收</span>
        <div class="info">
          <p>
            {{ accept.recipient_province }}{{ accept.recipient_city
            }}{{ accept.recipient_district }}{{ accept.recipient_address }}
            {{
              accept.recipient_postcode
                ? `(邮编:${accept.recipient_postcode})`
                : ""
            }}
          </p>
          <p class="text-right">{{ accept.recipient_name }} (收)</p>
        </div>
      </div>
      <div class="section">
        <span class="prefix">寄</span>
        <div class="info">
          <p>
            {{ accept.send_province }}{{ accept.send_city
            }}{{ accept.send_district }}{{ accept.send_address }}
          </p>
          <p class="text-right">
            <span class="phone">{{ accept.send_phone }}</span
            >{{ accept.send_name }} (寄)
            {{ accept.relationship ? `(关系:${accept.relationship})` : "" }}
          </p>
        </div>
      </div>
    </div>
    <button @click="handlePrint" class="print-button">打印</button>
  </div>
</template>

<script setup lang="ts">
import { PropType, onMounted } from "vue";
import { ProductOrder } from "@/api/models/product_order/ProductOrder";

const props = defineProps({
  accept: {
    type: Object as PropType<ProductOrder>,
    required: true,
  },
});

// 声明全局函数和变量
declare const getLodop: (oOBJECT?: any, oEMBED?: any) => any;

let LODOP: any;

onMounted(() => {
  // 获取 LODOP 对象
  LODOP = getLodop();
  // 设置许可证（根据实际需求替换）
  if (LODOP) {
    LODOP.SET_LICENSES(
      "",
      "EE0887D00FCC7D29375A695F728489A6",
      "C94CEE276DB2187AE6B65D56B3FC2848",
      ""
    );
  }
});

const handlePrint = () => {
  if (!LODOP) {
    alert("无法获取 LODOP 对象，请检查 CLodop 服务");
    return;
  }
  const strHTML = document.getElementById("print-template")!.innerHTML;
  LODOP.PRINT_INITA(0, 0, 78, 49, "热敏纸打印");
  LODOP.SET_PRINTER_INDEXA("KM-118M");
  LODOP.SET_PRINT_PAGESIZE(1, "79mm", "50mm", "");
  LODOP.ADD_PRINT_HTM(0, 0, "79mm", "50mm", strHTML);
  LODOP.SET_PRINT_MODE("POS_BASEON_PAPER", true);
  LODOP.PRINT();
};
</script>

<style scoped>
.page-container {
  min-height: 20%;
  background: linear-gradient(to bottom, #e6f0ff, #f2f2f2);
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.print-card {
  background-color: #ffffff;
  width: 78mm;
  height: 49mm;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.section {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 8px;
}

.section:last-child {
  border-bottom: none;
  padding-top: 8px;
}

.prefix {
  font-size: 32px;
  font-weight: bold;
  color: #1f2937;
  margin-right: 8px;
  flex-shrink: 0;
}

.info {
  flex: 1;
  font-size: 14px;
  line-height: 1.4;
  color: #374151;
}

.info p {
  margin: 0;
}

.text-right {
  text-align: right;
}

.phone {
  margin-right: 8px;
}

.print-button {
  margin-top: 20px;
  background-color: #2563eb;
  color: #ffffff;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.print-button:hover {
  background-color: #1d4ed8;
}
</style>
